<template>
  <div class="bg-gray">
    <div class="mine-box-title">备案申请</div>
    <div class="mini-form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位名称" prop="name">
              <el-input
                  type="text"
                  placeholder="请输入单位名称"
                  v-model="formData.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="formData.type">
              <el-radio :label="1">幼儿园</el-radio>
              <el-radio :label="2">小学</el-radio>
              <el-radio :label="3">中学</el-radio>
              <el-radio :label="4">大学</el-radio>
              <el-radio :label="5">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="省市" prop="namekey">
              <el-cascader
                  v-model="formData.namekey"
                  ref="namekey"
                  @change="handleNamekeyChange"
                  :options="namekeyList"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item v-show="false" label="地区选择" prop="area">
              <el-cascader
                  v-model="formData.area"
                  ref="areas"
                  @change="handleAreasChange"
                  :options="areaOptions"
                  :props="{ label: 'title' }"
              ></el-cascader>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="详细地址" prop="address">
              <el-input
                  type="text"
                  placeholder="请输入详细地址"
                  v-model="formData.address"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider>联系人信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="nickname">
              <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="formData.nickname"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="certificatenumber">
              <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="formData.certificatenumber"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证件照片" prop="certificatepic">
              <PicUploader :fileList="formData.certificatepic" :limit="2"></PicUploader>
              <div class="form-label-desc">上传身份证件图片正反面</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                  type="text"
                  placeholder="请输入邮箱"
                  v-model="formData.email"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input
                  type="text"
                  placeholder="请输入手机号"
                  v-model="formData.phone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="QQ" prop="qq">
              <el-input
                  type="text"
                  placeholder="请输入QQ"
                  v-model="formData.qq"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="微信号" prop="weixin">
              <el-input
                  type="text"
                  placeholder="请输入微信号"
                  v-model="formData.weixin"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

<!--        <el-row>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="申报级别" prop="grade">-->
<!--              <el-select-->
<!--                  v-model="formData.grade"-->
<!--                  placeholder="请选择"-->
<!--                  class="inputSizeClass"-->
<!--                  @change="onGradeChange"-->
<!--              >-->
<!--                <el-option-->
<!--                    v-for="item in gradeOptions"-->
<!--                    :key="item.id"-->
<!--                    :label="item.name"-->
<!--                    :value="item.name"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row v-show="formData.registstatus==0||formData.registstatus==3">
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">提交备案
            </el-button>
            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

export default {
  name: 'CertDanweiApply',
  components: {
    PicUploader,
  },
  data: function () {
    return {
      areaOptions: [],
      namekeyList: [],
      saveLoading: false,
      showArea: false,
      showNamekey: false,
      gradeOptions: [],
      courseOptions: [],
      rules: {
        name: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        namekey: [{ required: true, message: "请选择省市", trigger: "change" }],
        area: [{ required: true, message: "请选择地区", trigger: "change" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        nickname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        certificatenumber: [
          { required: true, message: "请输入正确的身份证号", trigger: "blur" },
          // { validator: validator.idCard, trigger: "blur" },
        ],
        certificatepic: [
          { required: true, message: "请上传身份证件正反面", trigger: "blur" }, 
        ],
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入正确的邮箱", trigger: "blur" },
          { validator: validator.email, trigger: "blur" },
        ],
      },
      formData: {
        id: 0,
        type: 1,
        areas: '',
        nprovince: '',
        registstatus: '',
        ncity: '',
        ncounty: '',
        province: '',
        city: '',
        county: '',
        certificatepic: [] // [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"},{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "备案申请"
    that.formData.id = this.$route.query.id || 0;
    that.fetch();
    that.getAreaOptions();
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels
      console.log('handleAreasChange',values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },

    handleNamekeyChange(values) {
      let data = this.$refs.namekey.getCheckedNodes()[0].pathLabels
      this.formData.namekey = values[2];
      this.formData.nprovince = data[0];
      this.formData.ncity = data[1];
      this.formData.ncounty = data[2];


      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },
    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称

      console.log(that.formData)
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.formData.certificatepic.length != 2) {
            this.$message.warning('请上传身份证正反面');
            return
          }
          that.saveLoading = true;
          that.$api.post("/api/danwei/apply", that.formData, (res) => {
            that.saveLoading = false;
            rbLink({
              name: 'CertDanweiResult',
            }, 'replace')
          }, (rs) => {
            that.$message.error(rs.msg)
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    fetch() {
      let that = this;
      that.$api.post('/api/danwei/detail', {}, (res) => {
        if (res.data.id > 0) {
          that.formData = res.data;
        }
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// CertDanweiApply.vue?1a333872